export const MUTATION_VIEW_STATE = "viewState";
export const MUTATION_BAR_ACTIVE = "barActive";
export const MUTATION_SETTINGS_LOAD = "settingsLoad";
